export const getEmployeeDetail = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      organizationId
      organizationUnitId
      organizationUnit {
        name
        createdAt
        updatedAt
        __typename
      }
      userId
      user {
        id
        username
        name
        email
        createdAt
        updatedAt
        __typename
      }
      nik
      status
      domicile
      managerId
      manager {
        __typename
        id
        user {
          __typename
          id
          name
          email
          username
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      jobTitles {
        items {
          jobTitleId
          jobTitle {
            title
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      socialMedias {
        items {
          socialMediaId
          socialMedia {
            name
            url
            iconUrl
            createdAt
            updatedAt
            __typename
          }
          username
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      positionHistories {
        items {
          id
          employeeId
          dateFrom
          dateUntil
          title
          officeName
          location
          description
          internalPosition
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      educationHistories {
        items {
          id
          employeeId
          schoolName
          entryYear
          graduationYear
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      assignmentHistories {
        items {
          id
          employeeId
          dateFrom
          dateUntil
          officeName
          title
          location
          description
          bodRelated
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activities {
        items {
          activityId
          activity {
            name
            createdAt
            updatedAt
            __typename
          }
          point
          datetime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      badges {
        items {
          id
          employeeId
          badgeId
          badge {
            id
            name
            description
            iconUrl
            createdAt
            updatedAt
            __typename
          }
          grantDate
          grantedById
          grantedBy {
            id
            userId
            user {
              id
              name
              email
              username
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      skills {
        items {
          id
          employeeId
          skillGroup
          skill
          name
          level
          progress
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      trainings {
        items {
          id
          employeeId
          date
          name
          description
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rewards {
        items {
          id
          employeeId
          date
          name
          description
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      objectives {
        items {
          id
          ownerId
          title
          description
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const getEmployeeIdsByUserId = /* GraphQL */ `
  query EmployeesByUserId($userId: ID!) {
    employeesByUserId(userId: $userId) {
      items {
        id
      }
    }
  }
`;

export const listEmployeesWithAttributes = /* GraphQL */ `
  query ListEmployees($filter: ModelEmployeeFilterInput, $limit: Int, $nextToken: String) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationId
        organizationUnitId
        userId
        user {
          id
          name
          username
          email
          createdAt
          updatedAt
          __typename
        }
        jobTitles {
          items {
            jobTitle {
              title
            }
          }
        }
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getEmployeeDetailBasic = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      userId
      user {
        name
        email
        username
      }
      status
      organizationUnitId
      organizationUnit {
        name
      }
      managerId
      manager {
        user {
          name
          email
          username
        }
      }
      socialMedias {
        items {
          socialMedia {
            iconUrl
            name
            url
          }
          username
        }
      }
    }
  }
`;

export const getOrganizationUnit = /* GraphQL */ `
  query GetOrganizationUnit($id: ID!) {
    getOrganizationUnit(id: $id) {
      id
      organizationId
      name
      parentId
      parent {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      children {
        nextToken
        items {
          id
          name
        }
        __typename
      }
      objectives {
        nextToken
        items {
          title
          ownerId
          id
          description
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
